<template>
  <div>
    <!--面包屑导航区-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!--卡片区-->
    <el-card class="box-card">
      <!-- gutter="20" 列与列之间的间隔
      :span="8"  具体列的所占有的宽度（24为整个屏幕宽度）-->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input placeholder="搜索师傅手机号(模糊搜索)" v-model="queryInfo.mobile" :clearable="true" @clear="getUserList">
            <el-button slot="append" icon="el-icon-search" @click="getWorker"></el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="搜索师傅姓名(模糊搜索)" v-model="queryInfo.workerName" :clearable="true" @clear="getUserList">
            <el-button slot="append" icon="el-icon-search" @click="getWorker"></el-button>
          </el-input>
        </el-col>


        <!-- <h1>{{ value }}</h1>
<h1>{{ userList }}22</h1> -->

      </el-row>
      <div style="display: flex; margin-left: 1px;">
        <div style="margin-left:1px">
          <template>
            <el-radio v-model="queryInfo.wna_status" label=" ">所有师傅</el-radio>
            <el-radio v-model="queryInfo.wna_status" label="0">申请注销的师傅</el-radio>
            <el-radio v-model="queryInfo.wna_status" label="1">已经注销的师傅</el-radio>
            <el-radio v-model="queryInfo.wna_status" label="2">审核拒绝的师傅</el-radio>
          </template>
          <br>
          <template>
            <el-radio v-model="queryInfo.wsdr_status" label=" ">所有师傅</el-radio>
            <el-radio v-model="queryInfo.wsdr_status" label="0">保证金退款申请中</el-radio>
            <el-radio v-model="queryInfo.wsdr_status" label="1">保证金退款审核通过</el-radio>
            <el-radio v-model="queryInfo.wsdr_status" label="2">保证金审核拒绝</el-radio>
          </template>
          <br>
          <template style="margin-left:1px">
            <el-radio v-model="queryInfo.wsd_total" label=" ">所有师傅</el-radio>
            <el-radio v-model="queryInfo.wsd_total" label="499">保证金大于499的师傅</el-radio>

          </template>
          <br>
          <template>
            <el-radio v-model="queryInfo.for_certification" label=" ">所有师傅</el-radio>
            <el-radio v-model="queryInfo.for_certification" label="1">需要人工审核的师傅</el-radio>

          </template>
        </div>
        <el-col :span="4">
          <el-button type="primary" @click="getWorker">搜索</el-button>
        </el-col>

      </div>


      <!-- <el-col :span="4">
          <el-button type="primary" @click="addUserDialogVisible = true">添加用户</el-button>
        </el-col> -->

      <!--分页-->
      <div style="display: flex; padding-right: 100px;">

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum" :page-sizes="[5, 12, 100, 500, 1000, 10000]" :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>

        <div class="block" style=" margin-left: 300px; ">
          <span class="demonstration"></span>
          <el-date-picker v-model="queryInfo.value2" align="right" type="date" placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
          </el-date-picker>
        </div>

      </div>


      <!--用户列表表格version_name-->
      <el-table :data="userList" style="width: 100%" border stripe>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="编号" width="100" prop="number"></el-table-column>
        <el-table-column label="手机" width="120" prop="mobile"></el-table-column>
        <el-table-column label="注册时间" width="160" prop="register_date"></el-table-column>
        <el-table-column label="实名姓名" width="110" prop="NAME"></el-table-column>
        <el-table-column label="师傅姓名" width="110" prop="id_card_name"></el-table-column>
        <el-table-column label="师傅worker_id" width="210" prop="worker_id"></el-table-column>
        <el-table-column label="性别" width="50" prop="sex"></el-table-column>
        <el-table-column label="名族" width="50" prop="nation"></el-table-column>
        <el-table-column label="年龄" width="50" prop="id_card_age"></el-table-column>


        <!-- <el-table-column label="worker_id" width="300" prop="worker_id"></el-table-column> -->

        <el-table-column label="手机品牌" width="80" prop="phone_brand"></el-table-column>
        <el-table-column label="手机型号" width="100" prop="phone_model"></el-table-column>
        <el-table-column label="版本号" width="70" prop="version_name"></el-table-column>
        <el-table-column label="ip对应地址" width="120" prop="ip_address"></el-table-column>
        <!-- <el-table-column label="手机品牌" width="120" prop="phone_brand1"></el-table-column> -->
        <el-table-column label="服务所在地址" width="150" prop="address_region"></el-table-column>
        <el-table-column label="服务具体地址" width="120" prop="address_detail"></el-table-column>
        <el-table-column label="服务类目" width="320" prop="service_category_ids"
          :formatter="handleFormatter"></el-table-column>
        <el-table-column label="服务类型" width="320" prop="service_mode_types"
          :formatter="handleModeTypes"></el-table-column>1
        <el-table-column label="服务区域" width="320" prop="service_region_ids" :formatter="handleArea"></el-table-column>

        <!-- <el-table-column label="邮箱" prop="Email"></el-table-column> -->
        <el-table-column label="保证金" prop="wsd_total"></el-table-column>
        <el-table-column label="部分修改过手机" width="120" prop="mobile_now"></el-table-column>
        <el-table-column label="状态" width="50">

          <template slot-scope="scope">
            <el-switch v-model="scope.row.enable_flag" active-color="#13ce66" @change="userStateChanged(scope.row)"
              inactive-color="#ddd"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <!-- <el-button type="success" size="mini" @click="updateUserDialog(scope.row)">修改</el-button> -->
            <el-button type="warning" round size="mini" @click="deleteUser(scope.row.worker_id)">删除师傅信息</el-button>
          </template>
        </el-table-column>
        <el-table-column label="人工审核" width="120">
          <template slot-scope="scope">
            <!-- <el-button type="success" size="mini" @click="updateUserDialog(scope.row)">修改</el-button> -->
            <!-- <el-button type="warning" round size="mini" @click="deleteUser(scope.row.worker_id)">人工审核</el-button> -->
            <el-button type="text" @click="open(scope.row)">人工审核</el-button>
          </template>
        </el-table-column>
      </el-table>

    </el-card>




    <!--添加用户对话框-->
    <el-dialog title="添加用户信息" :visible.sync="addUserDialogVisible" width="40%" @close="addDialogClosed">
      <el-form ref="addFormRef" :rules="addFormRules" :model="addForm" label-width="80px">
        <el-form-item label="用户名" prop="NAME">
          <el-input v-model="addForm.NAME"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input v-model="addForm.password"></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="addForm.email"></el-input>
        </el-form-item>

        <el-form-item label="电话" prop="mobile">
          <el-input v-model="addForm.mobile"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUser">确 定</el-button>
      </span>
    </el-dialog>
    <!--修改用户信息对话框-->
    <el-dialog title="修改用户信息" :visible.sync="updateUserDialogVisible" width="40%" @close="updateDialogClosed">
      <el-form ref="updateFormRef" :rules="addFormRules" :model="updateForm" label-width="80px">
        <el-form-item label="用户名" prop="NAME">
          <el-input v-model="updateForm.NAME"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input v-model="updateForm.password" disabled></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="updateForm.email"></el-input>
        </el-form-item>

        <el-form-item label="电话" prop="mobile">
          <el-input v-model="updateForm.mobile"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateUser">确 定</el-button>
      </span>
    </el-dialog>
    <ShengheModal :dialogVisible="dialogVisible" :record="record" :handleClose="handleClose"
      @workerCertification="workerCertification" />
  </div>
</template>

<script>
import ShengheModal from './shengheModal.vue'
export default {
  components: { ShengheModal },
  data() {
    //自定义验证邮箱规则
    var checkEmail = (rule, value, callback) => {
      //正则表达式-邮箱
      const regEmail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
      if (regEmail.test(value)) {
        //合法邮箱
        callback()
      }
      callback(new Error('请输入合法的邮箱地址！'))
    }
    //自定义验证手机号码规则
    var checkMobile = (rule, value, callback) => {
      //正则表达式-手机
      const regMobile = /^1[3456789]\d{9}$/
      if (regMobile.test(value)) {
        //合法手机
        callback()
      }
      callback(new Error('请输入合法的手机号码！'))
    }



    return {
      dialogVisible: false,
      record: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '一月前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', date);
          }
        }]
      },
      value1: '',
      value2: '',



      queryInfo: {
        query: '',
        pagenum: 1,
        pagesize: 6,
        mobile: '',
        workerName: '',
        wna_status: '',
        wsdr_status: '',
        for_certification: '',
        wsd_total: '',
        radio: '',
        value2: ''
      },
      userList: [{
        enable_flag: 'ture'

      }],
      radio: '',
      total: 0,
      addUserDialogVisible: false,
      updateUserDialogVisible: false,
      addForm: {
        NAME: '',
        password: '',
        email: '',
        mobile: ''

      },
      updateForm: {
        NAME: '',
        password: '',
        email: '',
        mobile: ''
      },
      categorie_view_list: [],
      addFormRules: {
        NAME: [
          //required 必填
          //message 信息提示
          //trigger 鼠标失去焦点时触发
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 15, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ]
      }
    }
  },

  // created() {
  //   this.getWorker()
  // },

  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    workerCertification(value) {
      let formData = new FormData();
      formData.append('_token', window.sessionStorage.getItem('tocken'));
      formData.append('worker_id', value.worker_id);//师傅id
      formData.append('status', value.status);//认证状态1拒绝,2通过
      formData.append('fail_reason', value.fail_reason);//拒绝理由

      this.axios.post(this.$Api.workerCertification, formData).then(res => {
       // this.getWorker()
        this.dialogVisible = false
        //this.userList = res.data.datas;
      })
        .catch(err => {
         // console.log('错误11', err);
        });

    },



    open(record) {
      this.record = record
      this.dialogVisible = true
    },

    //服务类目
    handleFormatter(row) {
      let idArr = row['service_category_ids'] //筛选出id,对象  1,2,14
      // console.log('服务类目-----11111', idArr)
      let re = idArr?.split(',') //id数组,数组  [ "1", "2", "14" ]
      // console.log('服务类目000', re)
      let result
      if (re) {


        result = re.map(item => {
          let target = this.categorie_view_list.find(obj => obj.id == item)//id+数组 
          //console.log('服务类目111', target)//家具对应数组
          if (target) {
            //console.log('服务类目222', target['cn_name']) //家具
            return target['cn_name']
          }
        })


      }
      // console.log('服务类目333', result)  //[ "家具", "灯具", "家电" ]
      // console.log('服务类目555', result?.join(',')) //家具,灯具,家电
      return result?.join(',')


    },






    //服务类型
    handleModeTypes(row) {

      let idArr = row['service_mode_types']

      let re = idArr?.split(',')
      let result
      if (re) {

        result = re.map(item => {
          let target = this.service_modes_list.find(obj => obj['server_type'] == item)
          if (target) {
            return target['cn_name']
          } else {
            return null
          }
        })
      }
      return result?.filter(item => item !== null).join(',')



    },



    //地址1  
    findArea(id) {

      let starter = id.slice(0, 2)
      // console.log('地址111', starter)
      let target = this.province_list.find(item => String(item.id).startsWith(starter))

      let arr = target.childs

      if (arr) {

        const re = this.getDeep(id, arr)
        return re
      }

    },

    //地址2
    getDeep(id, childs) {

      for (let i = 0; i < childs.length; i++) {
        const obj = childs[i];
        if (obj.id == id) {
          return obj.name
        }
        if (obj.childs) {
          const res = this.getDeep(id, obj.childs)
          if (res) return res
        }
      }
    },



    //地址3
    handleArea(row) {
      // return  row['service_region_ids']
      let areaIds = row['service_region_ids']?.split(',')
      let arr
      if (areaIds) {
        arr = areaIds.map(item => this.findArea(item))
      }


      return arr?.join(',')
    },







    //1服务类目
    getCategory() {
      this.axios.get(this.$Api.serviceCategory).then((res) => {
        //console.log("主分类列表", res.data.datas);
        //读取所有分类数据
        this.categorie_view_list = res.data.datas;
        // console.log("服务类目111", this.categorie_view_list)
        // 全部服务类目加载完成过渡动画
        // this.publishPageAlready = true;
        // this.getLastCategory(); //5记忆服务类目和类型和下单方式

      });

    },

    //2服务模式
    ServiceMode() {
      let formData = new FormData();
      formData.append('server_category_id', '');
      this.axios.post(this.$Api.serviceMode, formData).then((res) => {
        //console.log("服务类型", res.data.datas);
        //读取所有分类数据
        this.service_modes_list = res.data.datas;
        // this.service_mode = this.service_modes_list.filter(
        //   (item) => item.id == this.serveInfo.service_mode_id
        // )[0];

      });

    },

    Address() {
      this.axios
        .get(this.$Api.address).then((res) => {
          this.province_list = res.data;

        });
    },



    getWorker() {
      if (this.queryInfo.value2 == null) {
        this.queryInfo.value2 = [];
      }
      let formData = new FormData();
      formData.append('_token', window.sessionStorage.getItem('tocken'));
      formData.append('page_current', this.queryInfo.pagenum || 1);//第几页
      formData.append('page_size', this.queryInfo.pagesize || 12);//状态
      formData.append('mobile', this.queryInfo.mobile);//第几页
      formData.append('name', this.queryInfo.workerName);//状态
      formData.append('wna_status', this.queryInfo.wna_status);//精确搜索：注销申请状态 0申请中 1审核通过 2审核拒绝queryInfo.value2
      formData.append('wsdr_status', this.queryInfo.wsdr_status);//精确搜索：申请退保证金状态 0申请中 1审核通过 2审核拒绝
      formData.append('for_certification', this.queryInfo.for_certification);//精确搜索：申请人工审核状态 空为全部 1筛选出手动认证的师傅
      formData.append('wsd_total', this.queryInfo.wsd_total);//比较搜索：不传返回全部，传0返回保证金大于等于0的，传1返回保证金大于等于100的，同理传100返回保证金大于等于100的
      formData.append('date_start', this.queryInfo.value2);//精确搜索：注销申请状态 0申请中 1审核通过 2审核拒绝queryInfo.value2
      this.axios.post(this.$Api.userWorker, formData).then(res => {
        // console.log('师傅列表', res.data.datas)
        // console.log("订单列表", res.data);
        // console.log("页数", res.data.page_total);
        this.userList = res.data.datas;
        this.total = res.data.page_total;
        //this.order_list = res.data.datas;
        this.loadingShow = false;
        // 分页信息
        this.order_pagination = res.data;
      })
        .catch(err => {
          //console.log('错误11', err.response);
        });
      //console.log(red)   userWorker
    },




    async getUserList() {
      const res = await this.$http.get('/api/users', {
        params: this.queryInfo
      })
      //console.log("用户", res.data.data)
      //this.userList = res.data.data
      //this.total = res.data.total
      //console.log(red)   userWorker
    },



    //switch 状态发生变化时的回调函数
    async userStateChanged(userinfo) {
      const res = await this.$http.get('/api/userupdate', { params: userinfo })
      if (res.data.count <= 0) return
      this.$message.success(
        res.data.count +
        '个状态信息已经修改成功！目前的状态的值为：' +
        res.data.newState
      )

      //真实开发环境下修改用户信息2
      // const d = await this.$http.put('user', userInfo)
      // if (d <= 0) return
      // this.$message.success('修改用户状态成功')
      //console.log(res.data)
    },
    //添加用户
    addUser() {
      //往addForm添加一些属性
      var query = 'query'
      var queryVal = this.queryInfo.query
      this.addForm[query] = queryVal

      var pagenum = 'pagenum'
      var pagenumVal = this.queryInfo.pagenum
      this.addForm[pagenum] = pagenumVal

      var pagesize = 'pagesize'
      var pagesizeVal = this.queryInfo.pagesize
      this.addForm[pagesize] = pagesizeVal

      this.$refs.addFormRef.validate(async valid => {
        if (valid) {
          const res = await this.$http.get('/api/adduser', {
            params: this.addForm
          })

          //真实开发环境下添加用户的接口的写法
          // const d = await this.$http.post('user/Add', this.addForm)
          // if (d <= 0) return
          // this.$message.success('添加用户成功')

          //console.log(res.data)
          this.userList = res.data.data
          this.total = res.data.total
          this.addUserDialogVisible = false
        }
      })
    },
    updateUserDialog(userInfo) {
      this.updateUserDialogVisible = true
      this.updateForm.id = userInfo.id
      this.updateForm.NAME = userInfo.NAME
      this.updateForm.password = userInfo.Password
      this.updateForm.email = userInfo.Email
      this.updateForm.mobile = userInfo.mobile
      //console.log(this.updateForm)
      //console.log(this.userInfo)
    },
    updateUser() {
      //往updateForm添加一些属性
      var query = 'query'
      var queryVal = this.queryInfo.query
      this.updateForm[query] = queryVal

      var pagenum = 'pagenum'
      var pagenumVal = this.queryInfo.pagenum
      this.updateForm[pagenum] = pagenumVal

      var pagesize = 'pagesize'
      var pagesizeVal = this.queryInfo.pagesize
      this.updateForm[pagesize] = pagesizeVal

      this.$refs.updateFormRef.validate(async valid => {
        if (valid) {
          const res = await this.$http.get('/api/updateuser', {
            params: this.updateForm
          })

          //真实开发环境下调用修改用户的接口的写法
          // const d = await this.$http.put('/api/updateuser', this.updateForm)
          // if (d <= 0) {
          //   return this.$message.error('修改用户信息失败')
          // }
          // this.$message.success('修改用户信息成功')
          // this.getUserList()

          //console.log(res.data)
          this.userList = res.data.data
          this.total = res.data.total
          this.updateUserDialogVisible = false
        }
      })
    },
    async deleteUser(worker_id) {
      var idInt = 'id'
      var idVal = worker_id
      this.queryInfo[idInt] = idVal
      //console.log('di',this.queryInfo)
      var res = await this.$confirm(
        '此操作将永久删除该用户, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => {
        return err
      })
      //console.log(res)
      if (res != 'confirm') return this.$message.info('删除用户已取消')
      // const resData = await this.$http.get('/api/deleteuser', {
      //   params: this.queryInfo
      // })

      //删除师傅

      let formData = new FormData();
      formData.append('_token', window.sessionStorage.getItem('tocken'));
      formData.append('worker_id', this.queryInfo[idInt]);// this.queryInfo.wsd_total
      formData.append('status', 1);
      this.axios.post(this.$Api.delWorker, formData).then(res => {

        let status = res.data.status;
        let message = res.data.message;
        if (status == 500 && message == '师傅已注销') {
          this.$message.error('师傅已经注销,不能继续注销哦')
        };
        if (status == 500 && message == '该师傅不存在注销申请') {
          this.$message.error('该师傅没有提交注销申请哦');
        }







        // console.log('删除师傅', status);
      })
        .catch(err => {
          // console.log('错误11', err.response);
        });
      //console.log(red)   userWorker

      //const resData =

      //真实开发环境下删除用户的接口调用
      // const d = await this.$http.delete('user/' + id)
      // if (d <= 0) return this.$message.error('删除用户失败')     
      // this.$message.success('删除用户成功')

      this.getWorker()
      //this.$message.info('删除用户成功')
      this.userList = resData.data.data
      this.total = resData.data.total
    },

    //监听修改用户对话框关闭事件
    updateDialogClosed() {
      this.$refs.updateFormRef.resetFields()
    },
    //监听pagesize改变的事件
    handleSizeChange(newsize) {
      this.queryInfo.pagesize = newsize
      this.getWorker()
      this.getUserList()
    },
    //监听PageNume改变的事件
    handleCurrentChange(newpage) {
      this.queryInfo.pagenum = newpage
      //console.log("监听多少页", newpage)
      this.getWorker()
      this.getUserList()
    },
    //监听添加用户的对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    }
  },
  created() {
    this.getCategory(),
      this.ServiceMode(),
      this.Address(),
      this.getUserList(),
      this.getWorker()

  }
}
</script>

<style scoped>
.el-table {
  margin-top: 10px;
}

.el-pagination {
  margin-top: 5px;
  text-align: left;
}
</style>